import { RootState } from "../store";
import { ILocation, IRestaurantGroup } from "./types";

export const selectCurrentLocation = (state: RootState): string =>
  state.appManager.currLocation;

export const selectCurrentRestaurantGroupId = (state: RootState): string =>
  state.appManager.currRestaurantGroupId;

export const selectAllRestaurantGroups = (
  state: RootState
): IRestaurantGroup[] => state.appManager.allRestaurantGroups;

export const selectAllLocations = (state: RootState): ILocation[] =>
  state.appManager.allLocations;

export const selectRestaurantGroupLocations = (state: RootState): ILocation[] =>
  state.appManager.restaurantGroupLocations;

export const selectFullRefreshLoader = (state: RootState): boolean =>
  state.appManager.isLoading;

export const selectCurrentLanguage = (state: RootState): "ru" | "en" | "kk" =>
  state.appManager.currLanguage;
